export const ASSETS = {
  deposit: "/assets/icons/deposit.svg",
  gram: "/assets/tokens/gram.png",
  lock: "/assets/icons/lock.svg",
  mtonga: "/assets/animations/mtonga.json",
  telegram: "/assets/icons/telegram.svg",
  ton: "/assets/icons/ton.svg",
  withdraw: "/assets/icons/withdraw.svg",
  zkresistor: "/assets/icons/zkresistor.svg",
} as const;
